import { Text, View, StyleSheet, Font } from '@react-pdf/renderer';
import moment from 'moment';
import { Fragment, useContext } from 'react';
import { GlobalContext } from '../../context/Provider';
import { dataType } from '../../pages/order/orderInterface';

Font.register({
    family: 'bold',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf",
    fontWeight: 'bold'
});

Font.register({
    family: 'italic',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-mediumitalic-webfont.ttf",
});
Font.register({
    family: 'italic-regular',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-italic-webfont.ttf",
});

Font.register({
    family: 'medium',
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf",
});


// Create styles
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        // flexGrow: 1,
    },
    w_20: {
        width: '20%'
    },
    w_30: {
        width: '30%'
    }
});

const InvoiceDetail = ({dataHolder}:dataType) => {
    const { authState,language_data} = useContext(GlobalContext)

    return (
        <Fragment>
            <View style={styles.container}>
                {/* Order Detail  */}
                <View style={styles.w_30}>
                    {/* Order id  */}
                    <Text style={[{ fontFamily: 'bold', marginBottom: 5 }]}>{language_data?.[authState.lang]?.common_order} {language_data?.[authState.lang]?.common_id}: {dataHolder?.order_id?dataHolder?.order_id:`${language_data?.[authState.lang]?.common_not_available}`}</Text>
                    <View style={[styles.container, { marginBottom: 5 }]}>
                        {/* Order date  */}
                        <Text style={[{ fontFamily: 'bold', marginRight: 3 }]}>{language_data?.[authState.lang]?.common_order} {language_data?.[authState.lang]?.common_date}:</Text>
                        <Text>{dataHolder?.created_at?moment(+dataHolder?.created_at).format('DD-MM-YYYY'):`${language_data?.[authState.lang]?.common_not_available}`}</Text>
                    </View>
                    {/* Invoice date  */}
                    <View style={[styles.container, { marginBottom: 5 }]}>
                        <Text style={[{ fontFamily: 'bold', marginRight: 3 }]}>{language_data?.[authState.lang]?.common_invoice} {language_data?.[authState.lang]?.common_date}: </Text>
                        <Text>{dataHolder?.created_at?moment(+dataHolder?.created_at).format('DD-MM-YYYY'):`${language_data?.[authState.lang]?.common_not_available}`}</Text>
                    </View>
                    {/* Pan Number  */}
                    {/* <View style={styles.container}>
                        <Text style={[{ fontFamily: 'bold', marginRight: 3 }]}>PAN:</Text>
                        <Text>AAECB1611P</Text>
                    </View> */}

                    {/* <Text></Text> */}
                </View>
                {/* Bill To  */}
                <View style={styles.w_30}>
                    <Text style={[{ fontFamily: 'bold' }]}>{language_data?.[authState.lang]?.common_bill} {language_data?.[authState.lang]?.common_to}</Text>
                    <Text style={[{ fontFamily: 'bold', marginBottom: 4 }]}>{dataHolder?.user_id?.name?dataHolder?.user_id?.name:`${language_data?.[authState.lang]?.common_not_available}`}</Text>
                    <Text  style={[{ width: '80%'}]}>{dataHolder?.address_id?.full_address?dataHolder?.address_id?.full_address:`${language_data?.[authState.lang]?.common_not_available}`}</Text>
                    {/* <Text>Square, Sector 74, Sahibzada</Text>
                    <Text>Ajit Singh Nagar, Mohali,</Text>
                    <Text>Punjab Mohali 160071 Punajb</Text> */}
                    {/* <Text>Phone: {dataHolder?.user_id?.phone_number?dataHolder?.user_id?.phone_number:'Not Available'}</Text> */}
                    <Text> {dataHolder?.user_id?.phone_no?`Phone:${dataHolder?.user_id?.phone_no}`:`${language_data?.[authState.lang]?.common_not_available}`}</Text>

                </View>
                {/* Ship To  */}
                <View style={styles.w_20}>
                    <Text style={[{ fontFamily: 'bold' }]}>{language_data?.[authState.lang]?.common_ship} {language_data?.[authState.lang]?.common_to}</Text>
                    <Text style={[{ fontFamily: 'bold', marginBottom: 4 }]}>{dataHolder?.user_id?.name?dataHolder?.user_id?.name:`${language_data?.[authState.lang]?.common_not_available}`}</Text>
                    <Text>{dataHolder?.address_id?.full_address?dataHolder?.address_id?.full_address:`${language_data?.[authState.lang]?.common_not_available}`}</Text>
                    {/* <Text>{dataHolder.user_id?.name?dataHolder.user_id?.name:'Not Available'}</Text> */}
                    {/* <Text>Square, Sector 74, Sahibzada</Text>
                    <Text>Ajit Singh Nagar, Mohali,</Text>
                    <Text>Punjab Mohali 160071 Punajb</Text> */}
                    <Text> {dataHolder?.user_id?.phone_no?`Phone:${dataHolder?.user_id?.phone_no}`:`${language_data?.[authState.lang]?.common_not_available}`}</Text>
                </View>
                {/* Warranty Text  */}
                <View style={styles.w_20}>
                    <Text style={[{ textAlign: 'right', fontFamily: 'italic-regular', marginBottom: 13 }]}></Text>
                    <Text style={[{ textAlign: 'right', fontFamily: 'italic-regular' }]}>*{language_data?.[authState.lang]?.common_keep} {language_data?.[authState.lang]?.common_this} {language_data?.[authState.lang]?.common_invoice} {language_data?.[authState.lang]?.common_and}</Text>
                    <Text style={[{ textAlign: 'right', fontFamily: 'italic-regular' }]}> {language_data?.[authState.lang]?.common_manufacturer} {language_data?.[authState.lang]?.common_box} {language_data?.[authState.lang]?.common_for} </Text>
                    <Text style={[{ textAlign: 'right', fontFamily: 'italic-regular' }]}> {language_data?.[authState.lang]?.common_warranty} {language_data?.[authState.lang]?.common_purpose}.</Text>
                </View>
            </View>
            {/* Total Items  */}
            <View style={styles.container}>
                <Text style={{ fontFamily: 'medium', marginTop: '20px' }}>{language_data?.[authState.lang]?.common_total} {language_data?.[authState.lang]?.common_item}: {language_data?.[authState.lang]?._1}</Text>
            </View>
            <View style={{ borderBottom: '1px solid #000', margin: '0px 0 10px' }}></View>
        </Fragment>
    )
}

export default InvoiceDetail;